import React, { ComponentType, ReactNode } from 'react';
import { TNotificationType } from 'src/models';
import {
  IconContainer,
  NotificationContainer,
  NotificationText,
  TextContainer,
} from './Notifications.styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { CloseButtonDefault } from './CloseButtonDefault';
import { MvpCanceledOrderModal } from '../../Modals/Canceled/MvpCanceled/MvpCanceledOrder';
import { t } from 'i18next';

export interface IGenericNotification {
  type: TNotificationType;
  text?: string | JSX.Element;
  Icon?: JSX.Element | null;
  CloseButtonComponent?: ComponentType;
  onClose?: () => void;
  children?: ReactNode;
  onConfirm?: () => void;
}

const GenericNotification = ({
  type,
  text,
  Icon,
  CloseButtonComponent,
  onClose,
  onConfirm,
}: IGenericNotification) => {
  const isFromMvpApp = useUrlParameterCheck('/app');
  const canceledTitle = t('CanceledExpiredInMvpAppHeader');

  return isFromMvpApp ? (
    <MvpCanceledOrderModal
      title={canceledTitle}
      onCancel={onClose}
      onConfirm={onConfirm}
    />
  ) : (
    <NotificationContainer type={type}>
      <IconContainer>{Icon}</IconContainer>
      <TextContainer>
        <NotificationText>{text}</NotificationText>
      </TextContainer>
      <CloseButtonDefault
        type={type}
        CloseButtonComponent={CloseButtonComponent}
        onClose={onClose}
      />
    </NotificationContainer>
  );
};

export default GenericNotification;
